// Config runtime: se carga desde /config.json al bootstrap (patrón Contabilidad MT)
// para poder cambiar apiBase / branding sin recompilar el bundle.
let _config = {
  brand: 'DPY Facturación Ágil',
  apiBase: '/qualita-client/rest',
  serverFE: '',
  env: 'dev',
  // Gate de seguridad: mientras esté en false, la pantalla funciona y calcula todo,
  // pero NO ejecuta el alta del comprobante (evita emisiones reales sin validar el payload).
  emisionHabilitada: false,
}

export async function loadConfig() {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' })
    if (res.ok) {
      _config = { ..._config, ...(await res.json()) }
    }
  } catch (e) {
    // si falla, se usan los defaults
    console.warn('No se pudo cargar /config.json, uso defaults', e)
  }
  return _config
}

export function getConfig() {
  return _config
}
